 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import COVER from '@/components/cover'
 import EBADFRONT from '@/components/ebadfront'
 import LOVE from '@/components/love'
 import LOVE_1 from '@/components/love_1'
 import TITLE from '@/components/title'
 import MAINTOC from '@/components/maintoc'
 import V11COVER from '@/components/v1/1cover'
 import V12TITLE_PAGE from '@/components/v1/2title_page'
 import V13CHAP1 from '@/components/v1/3chap1'
 import V14CHAP2 from '@/components/v1/4chap2'
 import V15CHAP3 from '@/components/v1/5chap3'
 import V16CHAP4 from '@/components/v1/6chap4'
 import V17CHAP5 from '@/components/v1/7chap5'
 import V18CHAP6 from '@/components/v1/8chap6'
 import V19CHAP7 from '@/components/v1/9chap7'
 import V110CHAP8 from '@/components/v1/10chap8'
 import V111CHAP9 from '@/components/v1/11chap9'
 import V112CHAP10 from '@/components/v1/12chap10'
 import V113CHAP11 from '@/components/v1/13chap11'
 import V114CHAP12 from '@/components/v1/14chap12'
 import V115CHAP13 from '@/components/v1/15chap13'
 import V116CHAP14 from '@/components/v1/16chap14'
 import V117CHAP15 from '@/components/v1/17chap15'
 import V118CHAP16 from '@/components/v1/18chap16'
 import V119CHAP17 from '@/components/v1/19chap17'
 import V120CHAP18 from '@/components/v1/20chap18'
 import V121CHAP19 from '@/components/v1/21chap19'
 import V122CHAP20 from '@/components/v1/22chap20'
 import V123CHAP21 from '@/components/v1/23chap21'
 import V124CHAP22 from '@/components/v1/24chap22'
 import V125CHAP23 from '@/components/v1/25chap23'
 import V126CHAP24 from '@/components/v1/26chap24'
 import V127CHAP25 from '@/components/v1/27chap25'
 import V128CHAP26 from '@/components/v1/28chap26'
 import V129CHAP27 from '@/components/v1/29chap27'
 import V130CHAP28 from '@/components/v1/30chap28'
 import V131CHAP29 from '@/components/v1/31chap29'
 import V132CHAP30 from '@/components/v1/32chap30'
 import V133CHAP31 from '@/components/v1/33chap31'
 import V134CHAP32 from '@/components/v1/34chap32'
 import V135CHAP33 from '@/components/v1/35chap33'
 import V136CHAP34 from '@/components/v1/36chap34'
 import V2COVER from '@/components/v2/cover'
 import V2UNTITLED1 from '@/components/v2/Untitled1'
 import V2UNTITLED11 from '@/components/v2/Untitled11'
 import V2UNTITLED12 from '@/components/v2/Untitled12'
 import V2UNTITLED13 from '@/components/v2/Untitled13'
 import V2UNTITLED14 from '@/components/v2/Untitled14'
 import V2UNTITLED15 from '@/components/v2/Untitled15'
 import V2UNTITLED16 from '@/components/v2/Untitled16'
 import V2UNTITLED17 from '@/components/v2/Untitled17'
 import V2UNTITLED18 from '@/components/v2/Untitled18'
 import V2UNTITLED19 from '@/components/v2/Untitled19'
 import V2UNTITLED110 from '@/components/v2/Untitled110'
 import V2UNTITLED111 from '@/components/v2/Untitled111'
 import V2UNTITLED112 from '@/components/v2/Untitled112'
 import V2UNTITLED113 from '@/components/v2/Untitled113'
 import V2UNTITLED114 from '@/components/v2/Untitled114'
 import V2UNTITLED115 from '@/components/v2/Untitled115'
 import V2UNTITLED116 from '@/components/v2/Untitled116'
 import V2UNTITLED117 from '@/components/v2/Untitled117'
 import V2UNTITLED118 from '@/components/v2/Untitled118'
 import V2UNTITLED119 from '@/components/v2/Untitled119'
 import V2UNTITLED120 from '@/components/v2/Untitled120'
 import V2UNTITLED121 from '@/components/v2/Untitled121'
 import V2UNTITLED122 from '@/components/v2/Untitled122'
 import V2UNTITLED123 from '@/components/v2/Untitled123'
 import V2UNTITLED124 from '@/components/v2/Untitled124'
 import V2UNTITLED125 from '@/components/v2/Untitled125'
 import V2UNTITLED126 from '@/components/v2/Untitled126'
 import V2UNTITLED127 from '@/components/v2/Untitled127'
 import V2UNTITLED128 from '@/components/v2/Untitled128'
 import V2UNTITLED129 from '@/components/v2/Untitled129'
 import V2UNTITLED130 from '@/components/v2/Untitled130'
 import V2UNTITLED131 from '@/components/v2/Untitled131'
 import V2UNTITLED132 from '@/components/v2/Untitled132'
 import V2UNTITLED133 from '@/components/v2/Untitled133'
 import V2UNTITLED134 from '@/components/v2/Untitled134'
 import V2UNTITLED135 from '@/components/v2/Untitled135'
 import V2UNTITLED136 from '@/components/v2/Untitled136'
 import V2UNTITLED137 from '@/components/v2/Untitled137'
 import V2UNTITLED138 from '@/components/v2/Untitled138'
 import V2UNTITLED139 from '@/components/v2/Untitled139'
 import V2UNTITLED140 from '@/components/v2/Untitled140'
 import V2UNTITLED141 from '@/components/v2/Untitled141'
 import V2UNTITLED142 from '@/components/v2/Untitled142'
 import V2UNTITLED143 from '@/components/v2/Untitled143'
 import V2UNTITLED144 from '@/components/v2/Untitled144'
 import V2UNTITLED145 from '@/components/v2/Untitled145'
 import V2UNTITLED146 from '@/components/v2/Untitled146'
 import V2UNTITLED147 from '@/components/v2/Untitled147'
 import V2UNTITLED148 from '@/components/v2/Untitled148'
 import V2UNTITLED149 from '@/components/v2/Untitled149'
 import V2UNTITLED150 from '@/components/v2/Untitled150'
 import V2UNTITLED151 from '@/components/v2/Untitled151'
 import V2UNTITLED152 from '@/components/v2/Untitled152'
 import V2UNTITLED153 from '@/components/v2/Untitled153'
 import V2UNTITLED154 from '@/components/v2/Untitled154'
 import V2UNTITLED155 from '@/components/v2/Untitled155'
 import V2UNTITLED156 from '@/components/v2/Untitled156'
 import V2UNTITLED157 from '@/components/v2/Untitled157'
 import V2UNTITLED158 from '@/components/v2/Untitled158'
 import V2UNTITLED159 from '@/components/v2/Untitled159'
 import V2UNTITLED160 from '@/components/v2/Untitled160'
 import V2UNTITLED161 from '@/components/v2/Untitled161'
 import V3COVER from '@/components/v3/cover'
 import V3TITLE from '@/components/v3/title'
 import V3FRONTMATTER from '@/components/v3/frontmatter'
 import V3CHAPTER01 from '@/components/v3/chapter01'
 import V3CHAPTER02 from '@/components/v3/chapter02'
 import V3CHAPTER03 from '@/components/v3/chapter03'
 import V3CHAPTER04 from '@/components/v3/chapter04'
 import V3CHAPTER05 from '@/components/v3/chapter05'
 import V3CHAPTER06 from '@/components/v3/chapter06'
 import V3CHAPTER07 from '@/components/v3/chapter07'
 import V3CHAPTER08 from '@/components/v3/chapter08'
 import V3CHAPTER09 from '@/components/v3/chapter09'
 import V3CHAPTER10 from '@/components/v3/chapter10'
 import V3CHAPTER11 from '@/components/v3/chapter11'
 import V3CHAPTER12 from '@/components/v3/chapter12'
 import V3CHAPTER13 from '@/components/v3/chapter13'
 import V3CHAPTER14 from '@/components/v3/chapter14'
 import V3CHAPTER15 from '@/components/v3/chapter15'
 import V3CHAPTER16 from '@/components/v3/chapter16'
 import V3CHAPTER17 from '@/components/v3/chapter17'
 import V3CHAPTER18 from '@/components/v3/chapter18'
 import V3CHAPTER19 from '@/components/v3/chapter19'
 import V3CHAPTER20 from '@/components/v3/chapter20'
 import V3CHAPTER21 from '@/components/v3/chapter21'
 import V3CHAPTER22 from '@/components/v3/chapter22'
 import V3CHAPTER23 from '@/components/v3/chapter23'
 import V3CHAPTER24 from '@/components/v3/chapter24'
 import V3CHAPTER25 from '@/components/v3/chapter25'
 import V3CHAPTER26 from '@/components/v3/chapter26'
 import V3CHAPTER27 from '@/components/v3/chapter27'
 import V3CHAPTER28 from '@/components/v3/chapter28'
 import V3CHAPTER29 from '@/components/v3/chapter29'
 import V3CHAPTER30 from '@/components/v3/chapter30'
 import V3CHAPTER31 from '@/components/v3/chapter31'
 import V3CHAPTER32 from '@/components/v3/chapter32'
 import V3CHAPTER33 from '@/components/v3/chapter33'
 import V3CHAPTER34 from '@/components/v3/chapter34'
 import V3CHAPTER35 from '@/components/v3/chapter35'
 import V3CHAPTER36 from '@/components/v3/chapter36'
 import V3CHAPTER37 from '@/components/v3/chapter37'
 import V3CHAPTER38 from '@/components/v3/chapter38'
 import V3CHAPTER39 from '@/components/v3/chapter39'
 import V3CHAPTER40 from '@/components/v3/chapter40'
 import V3CHAPTER41 from '@/components/v3/chapter41'
 import V3CHAPTER42 from '@/components/v3/chapter42'
 import V3CHAPTER43 from '@/components/v3/chapter43'
 import V3CHAPTER44 from '@/components/v3/chapter44'
 import V3CHAPTER45 from '@/components/v3/chapter45'
 import V3CHAPTER46 from '@/components/v3/chapter46'
 import V3CHAPTER47 from '@/components/v3/chapter47'
 import V3CHAPTER48 from '@/components/v3/chapter48'
 import V3CHAPTER49 from '@/components/v3/chapter49'
 import V3CHAPTER50 from '@/components/v3/chapter50'
 import V3CHAPTER51 from '@/components/v3/chapter51'
 import V3CHAPTER52 from '@/components/v3/chapter52'
 import V3CHAPTER53 from '@/components/v3/chapter53'
 import V3CHAPTER54 from '@/components/v3/chapter54'
 import V3CHAPTER55 from '@/components/v3/chapter55'
 import V3CHAPTER56 from '@/components/v3/chapter56'
 import V3CHAPTER57 from '@/components/v3/chapter57'
 import V41COVER from '@/components/v4/1cover'
 import V42TITLE_PAGE from '@/components/v4/2title_page'
 import V43TOC from '@/components/v4/3TOC'
 import V44CHAP1 from '@/components/v4/4chap1'
 import V45CHAP2 from '@/components/v4/5chap2'
 import V46CHAP3 from '@/components/v4/6chap3'
 import V47CHAP4 from '@/components/v4/7chap4'
 import V48CHAP5 from '@/components/v4/8chap5'
 import V49CHAP6 from '@/components/v4/9chap6'
 import V410CHAP7 from '@/components/v4/10chap7'
 import V411CHAP8 from '@/components/v4/11chap8'
 import V412CHAP9 from '@/components/v4/12chap9'
 import V413CHAP10 from '@/components/v4/13chap10'
 import V414CHAP11 from '@/components/v4/14chap11'
 import V415CHAP12 from '@/components/v4/15chap12'
 import V416CHAP13 from '@/components/v4/16chap13'
 import V417CHAP14 from '@/components/v4/17chap14'
 import V418CHAP15 from '@/components/v4/18chap15'
 import V419CHAP16 from '@/components/v4/19chap16'
 import V420CHAP17 from '@/components/v4/20chap17'
 import V421CHAP18 from '@/components/v4/21chap18'
 import V422CHAP19 from '@/components/v4/22chap19'
 import V423CHAP20 from '@/components/v4/23chap20'
 import V424CHAP21 from '@/components/v4/24chap21'
 import V425CHAP22 from '@/components/v4/25chap22'
 import V426CHAP23 from '@/components/v4/26chap23'
 import V427CHAP24 from '@/components/v4/27chap24'
 import V428CHAP25 from '@/components/v4/28chap25'
 import V429CHAP26 from '@/components/v4/29chap26'
 import V430CHAP27 from '@/components/v4/30chap27'
 import V431CHAP28 from '@/components/v4/31chap28'
 import V432CHAP29 from '@/components/v4/32chap29'
 import V433CHAP30 from '@/components/v4/33chap30'
 import V434CHAP31 from '@/components/v4/34chap31'
 import V435CHAP32 from '@/components/v4/35chap32'
 import V436CHAP33 from '@/components/v4/36chap33'
 import V437CHAP34 from '@/components/v4/37chap34'
 import V438CHAP35 from '@/components/v4/38chap35'
 import V439CHAP36 from '@/components/v4/39chap36'
 import V440CHAP37 from '@/components/v4/40chap37'
 import V441CHAP38 from '@/components/v4/41chap38'
 import V442CHAP39 from '@/components/v4/42chap39'
 import V443CHAP40 from '@/components/v4/43chap40'
 import LOVE_2 from '@/components/love_2'
 import COPYRIGHT from '@/components/copyright'
 import ORIMAD from '@/components/ORIMad'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
	{
 			"path" : "/",
 			"name" : "home",
 			"component" : Home
 		},
 		{
 			"path" : "/cover",
 			"name" : "cover",
 			"component" : COVER
 		},
 		{
 			"path" : "/ebadfront",
 			"name" : "ebadfront",
 			"component" : EBADFRONT
 		},
 		{
 			"path" : "/love",
 			"name" : "love",
 			"component" : LOVE
 		},
 		{
 			"path" : "/love_1",
 			"name" : "love_1",
 			"component" : LOVE_1
 		},
 		{
 			"path" : "/title",
 			"name" : "title",
 			"component" : TITLE
 		},
 		{
 			"path" : "/maintoc",
 			"name" : "maintoc",
 			"component" : MAINTOC
 		},
 		{
 			"path" : "/v1/1cover",
 			"name" : "v1/1cover",
 			"component" : V11COVER
 		},
 		{
 			"path" : "/v1/2title_page",
 			"name" : "v1/2title_page",
 			"component" : V12TITLE_PAGE
 		},
 		{
 			"path" : "/v1/3chap1",
 			"name" : "v1/3chap1",
 			"component" : V13CHAP1
 		},
 		{
 			"path" : "/v1/4chap2",
 			"name" : "v1/4chap2",
 			"component" : V14CHAP2
 		},
 		{
 			"path" : "/v1/5chap3",
 			"name" : "v1/5chap3",
 			"component" : V15CHAP3
 		},
 		{
 			"path" : "/v1/6chap4",
 			"name" : "v1/6chap4",
 			"component" : V16CHAP4
 		},
 		{
 			"path" : "/v1/7chap5",
 			"name" : "v1/7chap5",
 			"component" : V17CHAP5
 		},
 		{
 			"path" : "/v1/8chap6",
 			"name" : "v1/8chap6",
 			"component" : V18CHAP6
 		},
 		{
 			"path" : "/v1/9chap7",
 			"name" : "v1/9chap7",
 			"component" : V19CHAP7
 		},
 		{
 			"path" : "/v1/10chap8",
 			"name" : "v1/10chap8",
 			"component" : V110CHAP8
 		},
 		{
 			"path" : "/v1/11chap9",
 			"name" : "v1/11chap9",
 			"component" : V111CHAP9
 		},
 		{
 			"path" : "/v1/12chap10",
 			"name" : "v1/12chap10",
 			"component" : V112CHAP10
 		},
 		{
 			"path" : "/v1/13chap11",
 			"name" : "v1/13chap11",
 			"component" : V113CHAP11
 		},
 		{
 			"path" : "/v1/14chap12",
 			"name" : "v1/14chap12",
 			"component" : V114CHAP12
 		},
 		{
 			"path" : "/v1/15chap13",
 			"name" : "v1/15chap13",
 			"component" : V115CHAP13
 		},
 		{
 			"path" : "/v1/16chap14",
 			"name" : "v1/16chap14",
 			"component" : V116CHAP14
 		},
 		{
 			"path" : "/v1/17chap15",
 			"name" : "v1/17chap15",
 			"component" : V117CHAP15
 		},
 		{
 			"path" : "/v1/18chap16",
 			"name" : "v1/18chap16",
 			"component" : V118CHAP16
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"component" : Last
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js